var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26172 11.0204V15.9904C4.26172 17.8104 4.26172 17.8104 5.98172 18.9704L10.7117 21.7004C11.4217 22.1104 12.5817 22.1104 13.2917 21.7004L18.0217 18.9704C19.7417 17.8104 19.7417 17.8104 19.7417 15.9904V11.0204C19.7417 9.20043 19.7417 9.20043 18.0217 8.04043L13.2917 5.31043C12.5817 4.90043 11.4217 4.90043 10.7117 5.31043L5.98172 8.04043C4.26172 9.20043 4.26172 9.20043 4.26172 11.0204Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6317 10.99L13.2017 11.88C13.2917 12.02 13.4917 12.16 13.6417 12.2L14.6617 12.46C15.2917 12.62 15.4617 13.16 15.0517 13.66L14.3817 14.47C14.2817 14.6 14.2017 14.83 14.2117 14.99L14.2717 16.04C14.3117 16.69 13.8517 17.02 13.2517 16.78L12.2717 16.39C12.1217 16.33 11.8717 16.33 11.7217 16.39L10.7417 16.78C10.1417 17.02 9.68173 16.68 9.72173 16.04L9.78173 14.99C9.79173 14.83 9.71173 14.59 9.61173 14.47L8.94173 13.66C8.53173 13.16 8.70173 12.62 9.33173 12.46L10.3517 12.2C10.5117 12.16 10.7117 12.01 10.7917 11.88L11.3617 10.99C11.7217 10.45 12.2817 10.45 12.6317 10.99Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardLink);
export default __webpack_public_path__ + "static/media/award-link.d84305a6e98fe72c911fbdac7888971a.svg";
export { ForwardRef as ReactComponent };